export const LOAD_DOCUMENT_SCORING_RESULT_STARTED = "LOAD_DOCUMENT_SCORING_RESULT_STARTED";
export const LOAD_DOCUMENT_SCORING_GRIDS_SUCCESS = "LOAD_DOCUMENT_SCORING_GRIDS_SUCCESS";
export const LOAD_DOCUMENT_SCORING_GRIDS_STARTED = "LOAD_DOCUMENT_SCORING_GRIDS_STARTED";
export const LOAD_DOCUMENT_SCORING_RESULT_SUCCESS = "LOAD_DOCUMENT_SCORING_RESULT_SUCCESS";
